import * as Sentry from '@sentry/vue'
import {
	ExtraErrorData as ExtraErrorDataIntegration,
	CaptureConsole as CaptureConsoleIntegration
} from '@sentry/integrations'

import { ENV, ENV_DEV_OR_STAGING, VUE_APP_VERSION } from '@/helpers/environment'

export default {
	install(Vue) {
		Sentry.init({
			Vue,
			dsn: 'https://eaf1a8decc454276894d6dd63066bb96@o1383508.ingest.sentry.io/4505087656919044',
			environment: ENV,
			release: VUE_APP_VERSION,
			integrations: [
				new ExtraErrorDataIntegration({}),
				new CaptureConsoleIntegration({
					levels: ['error', 'warn']
				})
			],
			ignoreErrors: ['TypeError: cancelled', 'AxiosError: Request aborted', 'getBattery'],
			beforeSend: (event, error) => {
				if (shouldFilterConsoleWarn(event)) {
					return null
				}

				if (ENV_DEV_OR_STAGING) {
					let message = event.message || error?.originalException?.message

					if (message && message.length > 60) {
						message = `${message.substr(0, 60)}…`
					}

					/* eslint-disable no-console */
					console.groupCollapsed(`%cSentry Logger [${event.level}]: ${message}`, 'color: #f00')
					console.log(event)
					console.groupEnd()
					/* eslint-enable no-console */
				}

				return event
			}
		})
	}
}

/**
 * Filter console warnings except console.warn on /survey/plan_ready
 */
function shouldFilterConsoleWarn(event) {
	return [
		event.level === 'warning',
		event.logger === 'console',
		!event.request?.url.includes('/survey/plan_ready') || event.message?.includes('Pixel')
	].every(Boolean)
}
